const baseURL = "https://aistage.yipinapp.com/";
const baseURLTemplate = "/ppt-addin";
// const baseURLTemplate = "/ppt-addin-g";
const baseURLGds = "/gds";
const baseURLGbo = "/gbo";
const baseURLDir = "/dir";
const baseUrlAn = "/an"
const platform = 1000;
const baseURLApi = "/pcs";
const baseURLSubsApi = "/subm";
const baseURLPaymentApi = "/payment";
const maxTranslatePages = 30;
const localLanguage = 'en';
// const localLanguage = 'zhHans';

export const wdConfigData = {
  baseURL,
  baseURLTemplate,
  baseURLGds,
  baseURLGbo,
  baseURLDir,
  baseUrlAn,

  baseURLApi,
  baseURLSubsApi,
  baseURLPaymentApi,

  platform,
  maxTranslatePages,
  localLanguage
}

export const userKeys = {
  key_welcome_Remember: "key_welcome_Remember",
  key_login_RememberMe: "key_login_RememberMe",
  key_login_AccountName: "key_login_AccountName",
  key_login_Password: "key_login_Password",

  // c user
  key_accessToken: "key_access_Token",
  key_refreshToken: "key_refresh_Token",
  
  key_globalAccessToken: "key_globalAccessToken",
  key_globalRefreshToken: "key_globalRefreshToken",
  key_accountName: "key_accountName",
  key_accountType: "key_accountType",
  key_corporationId: "key_corporationId",
  key_deviceId: "key_deviceId",
  key_clientInstallationId: "key_clientInstallationId",
  key_corporationAccessToken: "key_corporationAccessToken",
  key_corporationObject: "key_corporationObject",
  key_userObject: "key_userObject",
  key_currentVersion: "key_currentVersion",

  key_serviceUrl_ImageHub: "key_serviceUrl_ImageHub",
  key_serviceUrl_Dir: "key_serviceUrl_Dir",
  key_serviceUrl_Task: "key_serviceUrl_Task",
  key_serviceUrl_Talk: "key_serviceUrl_Talk",
  key_serviceUrl_Calendar: "key_serviceUrl_Calendar",
  key_serviceUrl_An: "key_serviceUrl_An",

  key_user_settings_image_style_index:"key_user_settings_image_style_index",
  key_user_settings_image_style:"key_user_settings_image_style",
  key_user_settings_image_mode:"key_user_settings_image_mode",
  key_user_settings_image_style_mode:"key_user_settings_image_style_mode",
  key_user_settings_preview_template_shape_data:"key_user_settings_preview_template_shape_data",
  key_user_settings_select_template_is_semantic:"key_user_settings_select_template_is_semantic",
  key_user_settings_select_template_is_semantic_whole:"key_user_settings_select_template_is_semantic_whole",
  key_user_generate_slide_is_change_one_page_template:"key_user_generate_slide_is_change_one_page_template",

  key_user_settings_swirecoke_template:"key_user_settings_swirecoke_template",
}

export const appIds = {
  individual_corporation_id: "4db819d0-99b4-42bd-0000-000000000000",

  appId_App: "E839AAC0-608A-4A74-8C60-71729670F0F5",
  appId_AppClientId: "e4a8b8ef-dc40-4f5b-96e7-da4f9daefe3d",
  appId_Dir: "B0DBA916-E3D2-4CE3-9350-05458E76C7D8",
  appId_Task: "29A6A8A4-3884-43F1-B855-106309000B43",
  appId_Talk: "4C553C91-C6FF-4195-A392-0A475C4764FB",
  appId_Calendar: "8587ABED-0FDC-4096-BD80-6B2675BA6B8B",
  appId_Performance: "",
  appId_File: "",
  appId_Training: "",
  appId_Gpt: "",
}

export const language_codes = {
  /**
   * "2052": "中文,"
   * "1033": "英语,"
   * "1041": "日语,"
   * "1031": "德语,"
   * "1036": "法语,"
   */
  ZH: "2052",
  EN: "1033",
  JP: "1041",
  GER: "1031",
  fr: "1036",
}
